import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const ShopCard = ({ product, index = 0 }) => {
  const { addItem } = useCart();
  const navigate = useNavigate();

  const buyNow = () => {
    addItem(product);
    navigate("/cart");
  };

  return (
    <div
      data-testid={`shop-card-${product.id}`}
      className="fade-up flex flex-col bg-[#FAF7F2] border border-[#C6A769]/50 rounded-sm overflow-hidden transition-all duration-500 hover:-translate-y-1.5"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      {/* Product image area */}
      <div className="relative aspect-[4/5] bg-[#F1EAE0] overflow-hidden">
        <img
          src={product.image}
          alt={product.image_alt || product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-105"
        />
        {product.badge && (
          <span
            data-testid={`shop-badge-${product.id}`}
            className="absolute top-4 right-4 bg-[#4A3F35] text-[#C6A769] text-[10px] font-semibold uppercase tracking-[0.18em] px-3 py-1.5 rounded-sm"
          >
            {product.badge}
          </span>
        )}
      </div>

      {/* Card body */}
      <div className="flex flex-col flex-1 p-8 sm:p-9">
        <p className="text-[11px] uppercase tracking-[0.24em] text-[#B08F50] mb-4">
          Digital Download
        </p>
        <h3 className="font-serif-display text-2xl sm:text-3xl leading-tight text-[#4A3F35]">
          {product.name}
        </h3>
        <div className="w-14 h-px bg-[#C6A769] my-5" />
        <p className="text-[15px] leading-relaxed text-[#6b5d50] flex-1">
          {product.description}
        </p>
        <div className="mt-7">
          <p className="font-serif-display text-2xl text-[#C6A769]">${product.price}</p>
          <p className="text-[11px] uppercase tracking-[0.16em] text-[#8A7D71] mt-1">
            One-Time &middot; Instant Download
          </p>
        </div>
        <button
          onClick={buyNow}
          data-testid={`shop-buy-${product.id}`}
          className="mt-6 w-full bg-[#C6A769] text-[#4A3F35] py-4 rounded-sm text-sm font-semibold uppercase tracking-[0.18em] transition-all duration-300 hover:bg-[#B08F50] hover:scale-[1.02]"
        >
          Buy Now
        </button>
      </div>
    </div>
  );
};

export default ShopCard;
